import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'

interface Params {
  ID: number
  ClientID: number
  // PersonID stored on the PersonTargetFeature row (the original granter,
  // NOT the target). The server-side DELETE matches it in SQL:
  //   DELETE ... WHERE Id=@Id AND ClientId=@ClientId AND PersonId=@PersonId
  // so the request must echo back the row's own granter PersonID, regardless
  // of who is calling. Auth on the endpoint is enforced via authorizePerson:
  // callers with the `person.*` JWT role (typical admin login) can pass any
  // PersonID; callers without it can only pass their own. Capture this from
  // the row returned by listPersonTargetFeatures.
  PersonID: number
}

export interface DeletePersonTargetFeature<P> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<void>>
}

export const deletePersonTargetFeature: DeletePersonTargetFeature<Params> = (
  http,
  {ID, ClientID, PersonID},
) => {
  try {
    return http.delete<void>(
      `/v1/featuresettings/persontarget/${ID}?clientid=${ClientID}&personid=${PersonID}`,
    )
  } catch (e) {
    if (e instanceof Error) {
      throw e
    } else {
      throw new Error(e as string)
    }
  }
}
